// extracted by mini-css-extract-plugin
module.exports = {"skeleton-record-list":"activityList_skeleton-record-list__S5gE1","record-list":"activityList_record-list__GLzxz"};